import {IDepartmentState, initialDepartmentState} from '@app/core/store/state/department.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {DepartmentActions, EDepartmentActions} from '@app/core/store/actions/department.actions';

export const departmentReducers = (
	state = initialDepartmentState,
	action: DepartmentActions | ErrorActions,
): IDepartmentState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EDepartmentActions.PostDepartment:
		case EDepartmentActions.GetDepartments: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EDepartmentActions.GetDepartmentsSuccess: {
			return {
				...state,
				isLoading: false,
				departments: action.departments
			};
		}
		case EDepartmentActions.PostDepartmentSuccess: {
			return {
				...state,
				isLoading: false,
				departments: [...state.departments, action.department],
			};
		}
		default:
			return state;
	}
};
